/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// import AuthLayout from "layouts/Auth.js";
// import RtlLayout from "layouts/RTL.js";
// import AdminLayout from "layouts/Admin.js";

// import PrivacyPolicies from "./layouts/PrivacyPolicies"

import { UserProvider } from './contexts/userContext';
import { AppProvider } from './contexts/appContext';
import { wsInit } from 'services/WService';
import 'assets/scss/material-dashboard-pro-react.scss?v=1.9.0';
import { ThemeProvider } from 'contexts/themeContext';
import App from 'App';

// wsInit();
// const hist = createBrowserHistory();

ReactDOM.render(
  // <StrictMode>
  <AppProvider>
    <ThemeProvider>
      <UserProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UserProvider>
    </ThemeProvider>
  </AppProvider>,
  // </StrictMode>
  document.getElementById('root')
);
